import React, { useState } from 'react';

import Layout from '../components/layout';
import Seo from '../components/seo';
import { ConversionTracking } from '../services/conversionTracking';

import '../style/index.scss';
import { Map } from '../components/Map';

const Inizia = ({ location }) => {
  const params = new URLSearchParams(location.search);
  const inviato = params.get('inviato');
  const [modalOn, setModalOn] = useState(inviato === 'ok');

  const handleFormSubmit = (event) => {
    // Prevent immediate navigation so tracking can be sent reliably
    event.preventDefault();
    // Track form submission before the form is actually submitted
    ConversionTracking.trackContactForm({
      form_name: 'contact_form',
      page: 'inizia',
      method: 'contact_form_submission'
    });
    // Resume the original form submission after allowing tracking to start
    const form = event.target;
    window.setTimeout(() => {
      if (form && typeof form.submit === 'function') {
        form.submit();
      }
    }, 100);
  };
  return (
    <>
      <Layout page='inizia'>
        <Seo title='Inizia la tua terapia' />
        <h2>Inizia la tua terapia e prenota un colloquio</h2>
        <p>
          Compila il modulo per essere contattat* dal dottore e discutere i
          dettagli del tuo primo incontro. Il dottore ti contatter&agrave;
          personalmente per organizzare un appuntamento secondo le tue esigenze.
        </p>
        <div id='form-wrapper'>
          <form
            action='https://us-central1-jacopo-biraschi-psicologo.cloudfunctions.net/inizia'
            method='POST'
            onSubmit={handleFormSubmit}
          >
            <div className='form-field'>
              <label htmlFor='name'>Nome*</label>
              <input
                className='flex-input'
                type='text'
                name='name'
                id='name'
                pattern='[\w\s]{3,20}'
                required
              ></input>
            </div>
            <div className='input-tip-right'>
              Usare solo lettere (min. 3 - max. 20)
            </div>
            <div className='form-field'>
              <label htmlFor='email'>Email*</label>
              <input
                className='flex-input'
                type='email'
                name='email'
                id='email'
                required
              ></input>
            </div>
            <div className='form-field'>
              <label htmlFor='phone'>Telefono</label>
              <input
                className='flex-input'
                type='phone'
                name='phone'
                id='phone'
                pattern='(\+|00)\d*'
              ></input>
            </div>
            <div className='input-tip-right'>Usare il formato +39 o 0039</div>
            <div className='form-field'>
              <label htmlFor='phone'>Messaggio</label>
              <textarea
                className='flex-input'
                name='message'
                id='message'
              ></textarea>
            </div>
            <div className='input-tip-right'>* campi obbligatori</div>
            <input type='submit' value='Invia la Richiesta' />
            <div className='input-tip'>
              Cliccando "Invia la Richiesta" si accetta il trattamento dei dati
              personali
            </div>
          </form>
        </div>
        <Map />
      </Layout>
      {modalOn && (
        <div id='modal' onClick={() => setModalOn(false)}>
          <div id='modal-content'>
            <h2>Grazie per averci contattato!</h2>
            <div>
              Il Dott. Biraschi ti contatter&agrave; nelle prossime 24 ore per
              confermare il tuo appuntamento.
            </div>
            <button onClick={() => setModalOn(false)}>Va bene</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Inizia;
